import { render } from "./Feeder.vue?vue&type=template&id=13464f6e&scoped=true"
import script from "./Feeder.vue?vue&type=script&lang=js"
export * from "./Feeder.vue?vue&type=script&lang=js"

import "./Feeder.vue?vue&type=style&index=0&id=13464f6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13464f6e"

export default script